<p-panel [toggleable]="true" [collapsed]="!isFirst()" toggler="header">
  <ng-template #header>
    <div class="flex items-center justify-between w-full gap-6">
      <span class="font-bold">
        {{ officeName() }}
      </span>
    </div>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <div class="p-4 relative">
    <div class="overflow-x-auto">
      <div class="flex gap-3 items-stretch min-w-max">
        <div class="flex flex-col min-w-[260px] flex-1 max-w-[320px]">
          <h3 class="text-center font-semibold mb-3 text-base">
            {{ 'project.steps.systemFlow.sendingSystem' | transloco }}
          </h3>
          <div class="grow">
            <app-hr-system-recording-card
              [moduleFunctions]="moduleFunctions()"
              [moduleSystemRecording]="newSystemCardData()"
              [centered]="true"
            />
          </div>
        </div>

        <div class="flex-1 flex items-center justify-center self-center min-w-[40px]">
          <i class="pi pi-arrow-right text-3xl! text-blue-500"></i>
        </div>

        <div class="flex flex-col min-w-0 self-center items-center shrink-0">
          <h3 class="text-center font-semibold mb-3 text-base">
            {{ 'project.steps.systemFlow.intermediateSystems' | transloco }}
          </h3>
          @let hrRows = hrIntegrationRows();
          @let nonHrRows = nonHrIntegrationRows();

          @if (hrRows.length + nonHrRows.length === 0) {
            <p-message severity="secondary" styleClass="w-full">
              {{ 'project.steps.systemFlow.noIntermediateSystems' | transloco }}
            </p-message>
          } @else {
            <div class="space-y-3">
              @for (row of hrRows; track $index; let last = $last) {
                <div class="flex items-center gap-3">
                  <div class="w-[180px] shrink-0">
                    <app-module-integration-config
                      [isReadOnly]="isReadOnly()"
                      [inputObject]="row.inboundInputObject"
                      [dataDomainOptions]="dataDomainOptions()"
                      [integrationTypeOptions]="integrationTypeOptions()"
                      (configChange)="addHrIntegrationConfigChangeToSaveMap($event)"
                    />
                  </div>

                  <div class="shrink-0 w-[300px]">
                    <app-hr-system-recording-card
                      [moduleFunctions]="moduleFunctions()"
                      [moduleSystemRecording]="row.recording"
                      [centered]="true"
                    />
                  </div>

                  <div class="w-[180px] shrink-0">
                    <app-module-integration-config
                      [isReadOnly]="isReadOnly()"
                      [inputObject]="row.outboundInputObject"
                      [dataDomainOptions]="dataDomainOptions()"
                      [integrationTypeOptions]="integrationTypeOptions()"
                      (configChange)="addHrIntegrationConfigChangeToSaveMap($event)"
                    />
                  </div>
                </div>

                @if (!last || (last && nonHrRows.length > 0)) {
                  <p-divider></p-divider>
                }
              }
              @for (row of nonHrRows; track $index; let last = $last) {
                <div class="flex items-center gap-3">
                  <div class="w-[180px] shrink-0">
                    <app-module-integration-config
                      [isReadOnly]="isReadOnly()"
                      [inputObject]="row.inboundInputObject"
                      [dataDomainOptions]="dataDomainOptions()"
                      [integrationTypeOptions]="integrationTypeOptions()"
                      (configChange)="addNonHrIntegrationConfigChangeToSaveMap($event)"
                    />
                  </div>

                  <div class="shrink-0 w-[300px]">
                    <app-non-hr-system-recording-card
                      [nonHrSystems]="moduleNonHrFunctions()"
                      [moduleNonHrSystemRecording]="row.recording"
                      [centered]="true"
                    />
                  </div>

                  <div class="w-[180px] shrink-0">
                    <app-module-integration-config
                      [isReadOnly]="isReadOnly()"
                      [inputObject]="row.outboundInputObject"
                      [dataDomainOptions]="dataDomainOptions()"
                      [integrationTypeOptions]="integrationTypeOptions()"
                      (configChange)="addNonHrIntegrationConfigChangeToSaveMap($event)"
                    />
                  </div>
                </div>

                @if (!last) {
                  <p-divider></p-divider>
                }
              }
            </div>
          }
        </div>

        <div class="flex-1 flex items-center justify-center self-center min-w-[40px]">
          <i class="pi pi-arrow-right text-3xl! text-green-500"></i>
        </div>

        <div class="flex flex-col min-w-[260px] flex-1 max-w-[320px]">
          <h3 class="text-center font-semibold mb-3 text-base">
            {{ 'project.steps.systemFlow.receivingSystem' | transloco }}
          </h3>
          <div class="grow">
            <app-hr-system-recording-card
              [moduleFunctions]="moduleFunctions()"
              [moduleSystemRecording]="newSystemCardData()"
              [centered]="true"
            />
          </div>
        </div>
      </div>
    </div>

    @if (showsSaveButton()) {
      <div class="flex justify-end mt-4">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        />
      </div>
    }
  </div>
</p-panel>
